import { useReveal } from "@/hooks/useReveal";

const ROWS = [
  { label: "Minimum order per SKU", value: "Half a container (10 tonnes)" },
  { label: "Realistic export commitment", value: "One to two 40 ft containers per quarter" },
  { label: "Container", value: "40 ft container, approximately 20 tonnes" },
  { label: "Default Incoterm", value: "FOB Cartagena or Buenaventura, Colombia" },
  { label: "Alternative Incoterm", value: "CIF to your port of destination, quoted on request" },
  { label: "Payment terms, first order", value: "Irrevocable confirmed letter of credit, or substantial advance payment" },
  { label: "Certification of the plant", value: "Ecocert USDA Organic and EU Organic, HACCP, INVIMA" },
];

export default function PlantCapacity() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="plant" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-2xl">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Plant, capacity and minimums
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Published deliberately. If the numbers do not work for you, you
            will know before you write to us.
          </p>
        </div>

        <div className="mt-12 max-w-3xl">
          <div className="border border-cream-dark/60 rounded-lg overflow-hidden">
            {ROWS.map((row, i) => (
              <div
                key={row.label}
                className={`grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-6 px-6 py-4 ${
                  i % 2 === 1 ? "bg-cream/60" : "bg-white"
                }`}
              >
                <div className="text-ink/60 text-sm font-semibold sm:font-medium sm:text-[15px]">
                  {row.label}
                </div>
                <div className="text-ink text-[17px] leading-relaxed">
                  {row.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}